import { CalendarDays, Warehouse, Truck } from "lucide-react";
import { zl, carLabel, plDate, SERVICE_LABELS } from "@/lib/api";

export const Summary = ({ ctx, title = "Podsumowanie", showTerm = false, children }) => {
  const { pkg, b, chosenAddons, total } = ctx;
  if (!pkg) return null;
  return (
    <aside data-testid="booking-summary" className="panel p-6 h-fit">
      <h3 className="font-display font-semibold mb-5">{title}</h3>
      <div className="space-y-3 text-sm">
        <div className="flex justify-between gap-4"><span>{pkg.name}</span><span data-testid="summary-base-price">{zl(pkg.prices[b.car])}</span></div>
        <div className="text-muted-foreground text-xs">{carLabel(b.car)}</div>
        {chosenAddons.map((a) => (
          <div key={a.id} className="flex justify-between gap-4 text-white/80"><span>{a.name}</span><span>+{zl(a.price)}</span></div>
        ))}
      </div>
      {showTerm && (
        <div className="mt-6 space-y-3 text-sm text-white/85">
          {b.date && <div className="flex items-center gap-3"><CalendarDays size={16} className="text-primary" />{plDate(b.date)} · {b.time}</div>}
          <div className="flex items-center gap-3">
            {b.service === "mobile" ? <Truck size={16} className="text-primary" /> : <Warehouse size={16} className="text-primary" />}
            {SERVICE_LABELS[b.service]}
          </div>
          {b.service === "stationary" && b.pickup && (
            <div data-testid="summary-pickup" className="flex items-center gap-3"><Truck size={16} className="text-primary" />Odbiór auta (+ dodatkowa opłata)</div>
          )}
        </div>
      )}
      <div className="border-t border-white/10 mt-6 pt-5 flex justify-between items-baseline">
        <span className="text-primary">Razem:</span>
        <span data-testid="summary-total" className="font-display text-3xl font-bold text-primary">{zl(total)}</span>
      </div>
      {children}
    </aside>
  );
};
